import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { workDesc } from './workList';

export default function Slider({ index }) {
  const workData = workDesc[index];
  const [currentSlide, setCurrentSlide] = useState(0);
  const slideRef = useRef(null);

  const handleClicButton = index => {
    setCurrentSlide(index);
  };

  useEffect(() => {
    slideRef.current.style.transition = 'all 0.5s ease-in-out';
    slideRef.current.style.transform = `translateX(-${currentSlide}00%)`; // 백틱을 사용하여 슬라이드로 이동하는 에니메이션을 만듭니다.
  }, [currentSlide]);

  return (
    <Container>
      <Title>
        {workData.work.map((item, i) => {
          return (
            <>
              {i !== workData.work.length - 1 ? (
                <span onClick={() => handleClicButton(i)}> {item.title} |</span>
              ) : (
                <span onClick={() => handleClicButton(i)}> {item.title}</span>
              )}
            </>
          );
        })}
      </Title>
      <SliderContainer ref={slideRef}>
        {workData.work.map((item, i) => {
          return (
            <Content key={i}>
              <ContTitle>{item.title}</ContTitle>
              {item.text}
              <img src="/images/work_layer.png" />
            </Content>
          );
        })}
      </SliderContainer>
      <Center>
        {workData.work.map((item, i) => {
          return (
            <Button
              currentSlide={currentSlide}
              index={i}
              key={i}
              onClick={() => handleClicButton(i)}
            ></Button>
          );
        })}
      </Center>
    </Container>
  );
}
const Container = styled.div`
  width: 800px;
  margin: auto;
  overflow: hidden; // 선을 넘어간 이미지들은 숨겨줍니다.
  padding: 100px 0;
  @media only screen and (max-width: 1200px) {
    width: 600px;
  }
  @media only screen and (max-width: 900px) {
    width: 500px;
  }
  @media only screen and (max-width: 700px) {
    width: 400px;
  }
  @media only screen and (max-width: 400px) {
    width: 300px;
    padding: 100px 0 50px;
  }
`;
const Title = styled.div`
  color: #f1bf78;
  font-size: 16px;
  text-align: left;
  margin-bottom: 40px;
  > span {
    cursor: pointer;
  }
`;
const Button = styled.div`
  display: inline-block;
  width: 10px;
  height: 10px;
  margin: 1em 1em;
  color: burlywood;
  border-radius: 50%;
  border: 1px solid burlywood;
  cursor: pointer;
  &:hover {
    background-color: burlywood;
    color: #fff;
  }
  ${({ currentSlide, index }) => {
    if (currentSlide === index) {
      return `background-color: burlywood;`;
    }
  }}
`;
const SliderContainer = styled.div`
  margin: 2em auto;
  display: flex; // 이미지들을 가로로 나열합니다.
  flex-wrap: nowrap;
  flex-direction: row;
  text-align: left;
  font-size: 18px;
  line-height: 28px;
`;
const Content = styled.div`
  color: #ffffff;
  width: 100%;
  img {
    width: 800px;
    height: 10px;
  }
`;
const ContTitle = styled.h1`
  color: #ffffff;
  font-weight: 800;
  font-size: 20px;
  margin-bottom: 20px;
`;
const Text = styled.div`
  text-align: center;
  color: burlywood;
  p {
    color: #fff;
    font-size: 20px;
    background-color: burlywood;
    display: inline-block;
    border-radius: 50px;
    padding: 0.5em 1em;
  }
`;
const Center = styled.div`
  text-align: center;
`;
